import { appliesQueryKeys } from "./query-keys";
import type { UseApplyFiltersParams } from "./useApplyFilters";

import type { AsyncFilterOptions } from "@/components/ui/v2/filters/FiltersDrawer";
import { useFilterOptionsInfinite } from "@/features/integrations/shared/api/useFilterOptionsInfinite";

/**
 * One dimension of the Applies filter drawer, paged on scroll and searched server-side. Counts are in
 * applies, matching the rows of the Applies table.
 */
export function useApplyFilterOptions(
  dimension: string,
  params: UseApplyFiltersParams,
  optionSearch: string,
  enabled: boolean,
): AsyncFilterOptions {
  const withSearch = { ...params, optionSearch: optionSearch || undefined };

  return useFilterOptionsInfinite(
    "/api/v2/Applies/FilterCounts",
    appliesQueryKeys.filterOptions(dimension, withSearch),
    dimension,
    withSearch,
    enabled,
  );
}
